export const TOKEN_EXPIRED = 'token_expired';
export const OPEN_FAVORITE_CLAIM = 'open_favorite_claim';
export const OPEN_MENU = 'open_menu';
export const OPEN_LOGIN_MODAL = 'open_login_modal';
export const OPEN_ALERT_MODAL = 'open_alert_modal';

export default {
  TOKEN_EXPIRED,
  OPEN_FAVORITE_CLAIM,
  OPEN_MENU,
  OPEN_LOGIN_MODAL,
  OPEN_ALERT_MODAL
};
